import siteConfig from '../config';
import { stringify } from '../helpers/query-string';
import logoSvg from '../assets/Logo/logo.svg';

const defaultParams = {
  websiteConfigId: siteConfig.websiteConfigId,
  consumerKey: siteConfig.consumerKey,
  includeBootstrap: false,
  includeJQuery: false,
};

const getParams = params => stringify({ ...defaultParams, ...params });
const getScriptUrl = (type, params) => `${siteConfig.seaticsScriptUrl}/${type}?${getParams(params)}`;

export const getEventScriptUrl = id => getScriptUrl('EventAndVenueInfo', { eventId: id });

export const getMapHeight = (navRef, footerRef, offsetTop) => {
  const nav = navRef || window.document.getElementsByTagName('nav')[0];
  const footer = footerRef || window.document.getElementsByTagName('footer')[0];

  const navHeight = nav ? nav.clientHeight : 0;
  const footerHeight = footer ? footer.clientHeight : 0;

  return window.innerHeight - navHeight - footerHeight - offsetTop;
};

const normalizeTicketlist = (ticketList = []) => ticketList.map(ticket => ({
  tgUserSec: ticket.section,
  tgUserRow: ticket.row,
  tgUserSeats: `${ticket.lowSeat}-${ticket.highSeat}`,
  tgQty: ticket.ticketQuantity || 4,
  tgPrice: ticket.actualPrice,
  tgSplitRuleId: 1,
  tgID: ticket.ticketId,
  tgNotes: ticket.notes,
  tgType: ticket.ticketGroupType || 1,
  tgClientData: {
    recommendationMessage: ticket.recommendationMessage,
    attributes: ticket.attributes,
    eventId: ticket.eventId,
    isElectronic: ticket.isElectronic,
    isInstant: ticket.isInstant,
    isMobile: ticket.isMobile,
  },
  raw: ticket,
}));

export const normalizeTicketData = (ticketList) => {
  const ticketData = normalizeTicketlist(ticketList).filter(ticket => !!ticket);

  return ticketData;
};

export const setSeaticsMapConfig = (options) => {
  const { config, SortOptions } = window.Seatics;

  const mergedConfig = {
    ...options,
    c3CheckoutDomain: siteConfig.c3CheckoutDomain,
    c3CurrencyCode: siteConfig.c3CurrencyCode,
    useC3: siteConfig.useC3,
  };

  Object.keys(mergedConfig).forEach(option => config[option] = mergedConfig[option]);

  config.defaultSort = SortOptions[options.defaultSort];

  const logo = `<a href=${window.location.origin}>
    <img src=${logoSvg} width="100%" />
  </a>`;

  config.eventInfoLeftCol = logo;
};

export const parseQuery = param => (param && param.indexOf('[') === 0) ? JSON.parse(param) : param;



// WEBPACK FOOTER //
// ./src/helpers/seatics.js